export const NSIR_MAPA_LOAD_COMPLETO = 'NSIR_MAPA_LOAD_COMPLETO';
export const NSIR_MAPA_FIND_SUCCESS = 'NSIR_MAPA_FIND_SUCCESS';
export const NSIR_MAPA_CLEAN_ALL = 'NSIR_MAPA_CLEAN_ALL';
